import React from 'react';
import { FindFavoriteProvider } from '../favorites/find_favorite_context';
import { UpdateURLProvider } from '@reverbdotcom/commons/src/components/with_update_url';
import { UpdateUrlType } from '@reverbdotcom/commons/src/components/with_update_url';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';

export interface Props {
  updateUrl: UpdateUrlType;
  children: React.ReactNode;

  // Used to force a rerender and refetch of find favorite data
  // if the marketplace page layout changes
  keySuffix: string;
}

export function MarketplaceProviders(props: Props) {
  const shouldUseFindFavoriteProvider = useExpEnabled(experiments.FAVORITE_BUTTON_RQL);

  if (shouldUseFindFavoriteProvider) {
    return (
      <FindFavoriteProvider key={`find-favorite-provider--${props.keySuffix}`}>
        <UpdateURLProvider updateUrl={props.updateUrl}>
          {props.children}
        </UpdateURLProvider>
      </FindFavoriteProvider>
    );
  }

  return (
    <UpdateURLProvider updateUrl={props.updateUrl}>
      {props.children}
    </UpdateURLProvider>
  );
}
